// One timeline for the whole call path - SIP registration, native call events,
// the SIP session itself - kept in window.__ghCallTrace so call-diagnostics.js
// can hand it over in one piece together with the native side's own log
// (GhVoip.getDiagnostics). The console lines carry the same timestamps, so a
// live Safari Web Inspector session and a saved report read the same way.
const TRACE_LIMIT = 300;

export function traceCall(event, detail = {}) {
    const entry = { t: new Date().toISOString(), event, ...detail };

    const trace = (window.__ghCallTrace ??= []);
    trace.push(entry);
    if(trace.length > TRACE_LIMIT) trace.splice(0, trace.length - TRACE_LIMIT);

    console.log(`[calls] ${event}`, JSON.stringify(entry));
}
